import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Join from "@/pages/Join";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/join" element={<Join />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
